import { ACCEPT_MAP_POLICY } from "../../../actionTypes";

export const acceptMapPolicy = () => {
	return {
		type: ACCEPT_MAP_POLICY,
	};
};
